// material-ui
import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";

// project-imports
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";

// ==============================|| ANIMATIONS ||============================== //

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0px); }
`;

const glow = keyframes`
  0% { filter: drop-shadow(0 0 6px rgba(120,180,255,0.2)); }
  50% { filter: drop-shadow(0 0 18px rgba(120,180,255,0.6)); }
  100% { filter: drop-shadow(0 0 6px rgba(120,180,255,0.2)); }
`;

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({ open }) => {
  const earthGlobeUrl = `${process.env.PUBLIC_URL || ""}/image/earth-globe.png`;

  return (
    <Box sx={{ flexGrow: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <SimpleBar
        sx={{
          flexGrow: 1,
          minHeight: 0,
          "& .simplebar-content": {
            display: "flex",
            flexDirection: "column",
          },
          "& .simplebar-content-wrapper": {
            overflowX: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          },
          "& .simplebar-content-wrapper::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Navigation open={open} />
      </SimpleBar>

      <Box
        aria-hidden
        sx={{
          display: open ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          height: 280,
          pb: 2.5,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        {/* FLOAT ANIMATION */}
        <Box
          sx={{
            animation: `${float} 6s ease-in-out infinite`,
          }}
        >
          {/* ROTATION ANIMATION */}
          <Box
            sx={{
              animation: `${rotate} 30s linear infinite`,
            }}
          >
            {/* IMAGE */}
            <Box
              component="img"
              src={earthGlobeUrl}
              alt=""
              sx={{
                width: 220,
                maxWidth: "90%",
                height: "auto",
                opacity: 0.9,
                userSelect: "none",
                filter: "hue-rotate(-120deg) saturate(1.8) brightness(0.65) drop-shadow(0 0 14px rgba(27,94,32,0.4))",
                "@media (prefers-reduced-motion: reduce)": {
                  animation: "none",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DrawerContent;
